import { InfoTip } from '@/components/Help/InfoTip';
import type { HelpTip } from '@/docs/tips/types';

interface KpiChartCardProps {
  title: string;
  description: string;
  children: React.ReactNode;
  /** "i" icon explaining the chart. */
  infoTip?: HelpTip;
}

/** Bordered card wrapping a titled chart inside a model panel. */
export const KpiChartCard = ({
  title,
  description,
  children,
  infoTip,
}: KpiChartCardProps) => (
  <div className="rounded-xl border border-gray-DBDFE9 bg-white p-5">
    <h3 className="mb-1 flex items-center gap-1.5 text-md font-semibold text-black-071336">
      {title}
      {infoTip && <InfoTip tip={infoTip} />}
    </h3>
    <p className="mb-4 text-xs text-gray-78829D">{description}</p>
    {children}
  </div>
);
